import { Maybe, rd } from '@passionware/monads';
import { Capability } from '__types__';
import { appScopeUtils } from 'v5/core/app-scope/appScope.types';
import { MergeServices } from 'v5/platform/ts/services';
import { WithAccessService } from 'v5/services/front/AccessService/AccessService';
import { WithFeatureService } from 'v5/services/front/FeatureService/FeatureService';
import { WithAppScopeService } from 'v5/services/internal/AppScopeService/AppScopeService';

export type ShortlistCreateEntry = 'legacy' | 'v5' | 'none';

/**
 * How "Create shortlist" is offered: with `shortlist-v5` off for the scope the
 * new shortlist goes to, today's legacy modal for everyone; with it on, the
 * v5 dialog for users with `SHORTLIST_CREATE` in the browsing scope and
 * nothing for the others. A flag still loading counts as off, a capability
 * still loading as not granted.
 */
export function useShortlistCreateEntry(
  services: MergeServices<
    [WithFeatureService, WithAccessService, WithAppScopeService]
  >,
  /** The workspace the new shortlist goes to; absent → the organization. */
  targetWorkspaceId: Maybe<number>
): ShortlistCreateEntry {
  const isV5 =
    rd.tryGet(
      services.featureService.useFeature(
        appScopeUtils.identityFromEntityWorkspace(
          services.appScopeService.useOrganizationId(),
          targetWorkspaceId
        ),
        'shortlist-v5'
      )
    ) === true;
  const canCreate =
    rd.tryGet(
      services.accessService.useCan(
        services.appScopeService.useResolvedScopeIdentity()
      )({ action: Capability.SHORTLIST_CREATE })
    ) === true;
  if (!isV5) return 'legacy';
  return canCreate ? 'v5' : 'none';
}
